import { useEffect } from 'react';
import { useOverlayContext } from 'seagull';
export const useAiSearchPartialToast = (param)=>{
    let { searchPartial, clearPartial, message, toastTestId } = param;
    const { showWarningToast } = useOverlayContext();
    useEffect(()=>{
        if (!searchPartial) return;
        showWarningToast(message, toastTestId);
        clearPartial();
    }, [
        searchPartial,
        message,
        clearPartial,
        toastTestId
    ]);
};
